import { render, staticRenderFns } from "./desktop.vue?vue&type=template&id=7bba734f&scoped=true"
import script from "./desktop.vue?vue&type=script&lang=js"
export * from "./desktop.vue?vue&type=script&lang=js"
import style0 from "./desktop.vue?vue&type=style&index=0&id=7bba734f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bba734f",
  null
  
)

export default component.exports